export default __webpack_public_path__ + "static/media/sec3.b56b980e.png";